import { Dataset, DEFAULT_PAGE_SIZE, DtFilter, DtSort } from '@/components/data-table/helpers';
import { McpServerModel } from '../models/mcp-server.model';
import { orderBy } from 'lodash';
import { get, post } from './sp-api.service';
import { ListResponse } from '.';
import { JsonObject } from '../helpers';
import { McpToolModel } from '../models/mcp-tool/mcp-tool.model';

const SAFE_LIMIT = 500;

export const getMcpServers = async (
  page = 0,
  pageSize: number = DEFAULT_PAGE_SIZE,
  dtSort?: DtSort,
  dtFilter?: DtFilter
): Promise<Dataset<McpServerModel>> => {
  const { data } = (await post('/mcp-catalog', {
    page: 1,
    pageSize: SAFE_LIMIT,
  })) as ListResponse;

  let rows = (data || []).map((row) => new McpServerModel(row));

  if (dtFilter?.keyword) {
    const safeKeyword = String(dtFilter?.keyword).toLowerCase();

    rows = rows.filter(({ name, title, description }) => {
      return [name, title, description].some((val) =>
        String(val).toLowerCase().includes(safeKeyword)
      );
    });
  }

  // Sort
  if (dtSort) {
    const { columnName, direction } = dtSort;

    switch (columnName) {
      case 'title':
        rows = orderBy(rows, [({ title }) => String(title).toLowerCase()], [direction]);
        break;
      default:
        rows = orderBy(rows, [columnName], [direction]);
        break;
    }
  }

  // Paginate
  const total = rows.length;
  const startIndex = page * pageSize;
  rows = rows.slice(startIndex, startIndex + pageSize);

  return {
    page,
    pageSize,
    rows,
    total,
  };
};

export const getAllMcpServers = async (): Promise<McpServerModel[]> => {
  const { rows } = await getMcpServers(0, SAFE_LIMIT);
  return rows;
};

export const getMcpServerById = async (id: string): Promise<McpServerModel | null> => {
  const response = (await get(`/mcp-catalog/servers/${id}`)) as JsonObject;
  return response ? new McpServerModel(response) : null;
};

export const getMcpToolsByServerId = async (id: string): Promise<McpToolModel[]> => {
  const { data } = (await get(`/mcp-catalog/servers/${id}/tools`)) as ListResponse;
  return (data || []).map((tool) => new McpToolModel(tool));
};

export const getMcpToolById = async (toolId: string): Promise<McpToolModel | null> => {
  const response = (await get(`/mcp-catalog/tools/${toolId}`)) as JsonObject;
  return response ? new McpToolModel(response) : null;
};

export const getAllMcpTools = async (): Promise<McpToolModel[]> => {
  const response = (await get('/mcp-catalog/tools', { limit: SAFE_LIMIT })) as ListResponse;
  return response?.data ? response.data.map((row) => new McpToolModel(row)) : [];
};
